import { inject as mobxInject } from 'mobx-react';
import { Stores } from 'stores';

export default function inject(...names: (keyof Stores)[]) {
  return mobxInject(...names);
}
